export default [
  {
    header: "ผู้ดูแลระบบ",
    menu: "Admin",
  },
  {
    title: "สิทธิ์การใช้งาน",
    icon: "CircleIcon",
    menu: "Role",
    children: [
      {
        title: "จัดการสิทธ์ผู้ใช้งาน",
        route: "DepartmentRole",
        icon: "CircleIcon",
      },
      {
        title: "จัดการสิทธ์การใช้ระบบ",
        route: "role",
        icon: "CircleIcon",
      },
    ],
  },

  {
    title: "บริหารเรื่องร้องทุกข์",
    route: null,
    icon: "CircleIcon",
    menu: "ComplaintManage",
  },
  {
    title: "ปรับแก้ไขเจ้าหน้าที่",
    route: null,
    icon: "CircleIcon",
    menu: "UserManage",
  },
  {
    title: "แนบเอกสารเพิ่มเติม",
    route: "attachment",
    icon: "CircleIcon",
    menu: "AdminAttachment",
  },
  {
    title: "ประวัติการเข้าใช้งานระบบ",
    route: null,
    icon: "CircleIcon",
    menu: "LoginLog",
  },
  {
    title: "ภาพรวมระบบ",
    route: "dashboard-analytics",
    icon: "CircleIcon",
    menu: "Dashboard",
  },
  {
    title: "ตั้งค่าระบบ",
    icon: "CircleIcon",
    menu: "Setting",
    children: [
      {
        title: "หมวดหมู่เรื่องร้องทุกข์",
        route: "MasterComplaintCategory",
        icon: "CircleIcon",
      },
      {
        title: "ประเภทร้องทุกข์",
        route: "MasterComplaintType",
        icon: "CircleIcon",
      },
      {
        title: "สาเหตุที่ต้องร้องทุกข์",
        route: "MasterComplaintCause",
        icon: "CircleIcon",
      },
      {
        title: "สถานที่ซื้อหรือใช้บริการ",
        route: "MasterPurchasePlace",
        icon: "CircleIcon",
      },
      {
        title: "ท่านรับทราบถึงตัวสินค้า หรือบริการผ่านช่องทางใด",
        route: "MasterPurchasePropagate",
        icon: "CircleIcon",
      },
      {
        title: "การชำระเงิน",
        route: "MasterPurchaseMethod",
        icon: "CircleIcon",
      },
      {
        title: "ความประสงค์",
        route: "MasterNotifyPurpose",
        icon: "CircleIcon",
      },
      {
        title: "เนื้อหาระบบ",
        route: "EditorDom",
        icon: "CircleIcon",
      },
      {
        title: "หน่วยงานภายใน",
        route: "InternalDepartment",
        icon: "CircleIcon",
      },
      {
        title: "หน่วยงานภายนอก",
        route: "ExternalDepartment",
        icon: "CircleIcon",
      },
      {
        title: "ระบบหน่วยงาน",
        route: "SystemDepartment",
        icon: "CircleIcon",
      },{
        title: "Webex Token",
        route: "WebexToken",
        icon: "CircleIcon",
      },
      {
        title: "จัดการช่องทางร้องทุกข์",
        route: "MasterComplaintChannel",
        icon: "CircleIcon",
      },
    ],
  },
  {
    title: "จัดการสถานะเรื่องร้องทุกข์",
    icon: "CircleIcon",
    menu: "ComplaintManage",
    children: [
      {
        title: "แก้ไขสถานะ",
        route: "ComplaintManage",
        icon: "CircleIcon",
      },
      {
        title: "ดึงเรื่องเข้าคัดกรอง",
        route: "ComplaintManageNull",
        icon: "CircleIcon",
      },
      {
        title: "แก้ไขสถานะแจ้งเบาะแส",
        route: "ClueAdmin",
        icon: "CircleIcon",
      },
      {
        title: "ตรวจสอบผู้ใช้งาน",
        route: "ComplaintManageUserInspect",
        icon: "CircleIcon",
      },
      {
        title: "แก้ไขเอกสารระบบร้องทุกข์",
        route: "DocumentManage",
        icon: "CircleIcon",
      },
    ],
  },
  {
    title: "ประวัติการใช้งาน",
    icon: "CircleIcon",
    menu: "AppLog",
    children: [
      {
        title: "ข้อมูลการส่งต่อเรื่องร้องทุกข์",
        route: "LogExternalService",
        icon: "CircleIcon",
      },
      {
        title: "ประวัติการใช้งานระบบ",
        route: "AppLog",
        icon: "CircleIcon",
      },
    ],
  },
  {
    title: "FastTrack",
    icon: "CircleIcon",
    menu: "LogFasttrack",
    children: [
      {
        title: "Dashboard",
        route: "dashboard-fasttrack",
        icon: "CircleIcon",
      },
      {
        title: "ตรวจสอบผู้ใช้งาน",
        route: "FasttrackUserInspect",
        icon: "CircleIcon",
      },
      {
        title: "ขั้นตอนการยืนยันตัวตน",
        route: "FastTrackAuthenticationLog",
        icon: "CircleIcon",
      },
      {
        title: "ขั้นตอนการทํางานที่สําคัญ",
        route: "FastTrackTransactionLog",
        icon: "CircleIcon",
      },
      {
        title: "ขั้นตอนเมื่อระบบเกิดข้อผิดพลาด",
        route: "FastTrackErrorLog",
        icon: "CircleIcon",
      },
    ],
  },
];
